<template>
    <div class="absolute w-full left-0 z-0">
        <div class="relative w-full aspect-w-1 aspect-h-1 overflow-hidden">
            <div>
                <div class="container relative h-full">
                    <div
                        class="absolute w-[130%] h-[130%] xl:w-[120%] xl:h-[120%] top-0 left-[50%] -translate-x-1/2 bg-contain bg-no-repeat opacity-50"
                        :style="`background-position: top center; background-image: url(${require('assets/images/shapes/shape-2_gray-500.png')})`"
                    ></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TopLocationBackgroundShape2',
};
</script>

<style scoped></style>
